module.exports = __webpack_public_path__ + "static/media/ic-arrow-right.1bd46b73.svg";